import { render } from "./FormDeletePage.vue?vue&type=template&id=4c011a76"
import script from "./FormDeletePage.vue?vue&type=script&lang=js"
export * from "./FormDeletePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__